import { Award, LineChart, Mic, Sparkles } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { localeUpperCase } from '../../lib/textCase';

// Mockup'ta 1. kart "Birebir Kariyer Koçluğu" idi — sistemde bire bir koçluk
// rezervasyon özelliği bulunmadığı için (karar gerekli — bkz. rapor) gerçek
// bir avantajla (MEB onaylı + CPD kayıtlı sertifika) değiştirildi.
const CARDS = [
  { key: 'card1', icon: Award, special: true },
  { key: 'card2', icon: LineChart },
  { key: 'card3', icon: Mic },
  { key: 'card4', icon: Sparkles, special: true },
];

export default function WhyUsSection() {
  const { t, lang } = useLanguage();

  return (
    <section className="bg-[#0B1A33] py-16 md:py-20 px-6 border-t border-white/[0.08]" data-testid="landing2-why-us">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-[1fr_1.3fr] gap-12 items-center">
        <div>
          <div className="text-xs font-bold tracking-widest text-[#C9A227]">
            {localeUpperCase(t('landing2.whyUs.eyebrow'), lang)}
          </div>
          <h2 className="landing2-display text-3xl md:text-[38px] mt-3 text-[#F7F5F0]">
            {localeUpperCase(t('landing2.whyUs.title'), lang)}
          </h2>
          <div className="inline-flex items-center gap-2.5 mt-6 bg-[#C9A227]/10 border border-[#C9A227]/35 rounded-2xl px-5 py-4">
            <Award size={26} className="text-[#C9A227] flex-shrink-0" aria-hidden="true" />
            <span className="text-sm font-semibold text-[#cdd6e3] max-w-[24ch]">
              {t('landing2.whyUs.statBadge')}
            </span>
          </div>
          <p className="text-[13px] text-[#8a97b8] mt-4 max-w-[34ch] leading-relaxed">
            {t('landing2.whyUs.statNote')}
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {CARDS.map((card) => {
            const Icon = card.icon;
            return (
              <div
                key={card.key}
                className={
                  'rounded-2xl border p-5 ' +
                  (card.special
                    ? 'bg-gradient-to-br from-[#123a24] to-[#0b1c38] border-[#34CC67]/40'
                    : 'bg-[#0b1c38] border-white/10')
                }
                data-testid={`why-us-${card.key}`}
              >
                <Icon size={22} className="text-[#F7F5F0]/85 mb-2.5" aria-hidden="true" />
                <h3 className="font-extrabold text-[16px] text-[#F7F5F0] mb-1.5">
                  {t(`landing2.whyUs.${card.key}.title`)}
                </h3>
                <p className="text-[13.5px] leading-relaxed text-[#b0bccc]">
                  {t(`landing2.whyUs.${card.key}.desc`)}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
